"use strict";

const MessageCtrl = function ($rootScope, CRUDService, config) {
    var ctrl = this;

    var currentPage = 0;
    var totalPages;

    ctrl.$onInit = function () {
      CRUDService.getAll(config.urls.messages, undefined, 'createdAt,desc').then(function (data) {
        ctrl.messages = data._embedded.messages;
        totalPages = data.page.totalPages;
      });
      CRUDService.getAll(config.urls.messages + '/search/count').then(function(data){
        $rootScope.user.messages = data;
      });
    };

    ctrl.getNextPage = function () {
      if ((currentPage + 1) < totalPages) {
        currentPage++;
        CRUDService.getAll(config.urls.messages, currentPage, 'createdAt,desc').then(function (data) {
          ctrl.messages = ctrl.news.concat(data._embedded.messages);
        });
      }
    };

    ctrl.remove = function (item) {
      CRUDService.remove(item._links.self.href).then(
        function () {
          ctrl.$onInit();
        });
    };

    ctrl.markRead = function (item) {
      item.unread = false;

      var msg = angular.copy(item);
      delete msg.sender;
      CRUDService.save(msg).then(function(){
        ctrl.$onInit();
      });
    };
  };

MessageCtrl.$inject = ['$rootScope', 'CRUDService', 'config'];

module.exports = {
  template: require('./messages.component.html'),
  controller: MessageCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/app/components/messages/messages.component.js